/* eslint-disable no-useless-computed-key */
import React from 'react';
import { AutoCompleteComponent } from "../../../../../Shared/components/AutoCompleteComponent";
import actions from "../../../redux/actions";
import { useSelector } from "react-redux";


export const CashReceiptDropDown = React.forwardRef((props, ref) => {
    const { dispatch, customObject, handleChangeCashReceipt } = props;
    const { storeSalesDetails } = useSelector(state => state.salesManagementReducer);


    const receiptApi = (search = '', id = '') => {
        let filter = { ["and"]: [{ salesType: 'Sale' }, { billStatus: "CONFIRMED", }, { isFullyReturned: null }] };
        let or = { ["or"]: [] };

        if (search !== undefined && search !== null && search !== '') {
            or['or'].push({ cashReceiptNumber: { like: '%' + search.trim() + '%' } });
        }


        if (id !== undefined && id !== null && id !== '') {
            or['or'].push({ id: id });
        }

        filter['and'].push(or);
        dispatch({
            type: actions.STORE_SALES_DETAILS_START, url: 'store-sales',
            filter: {
                where: filter,
                order: 'id desc',
                limit: 50,
                skip: 0
            },
        });
    }

    return (
        <AutoCompleteComponent
            customLabel={"Please search here receipt number"}
            heads={[{ 'key': 'cashReceiptNumber', 'name': 'Receipt Number' }, { 'key': 'invoiceAmount', 'name': 'Amount' }]}
            details={storeSalesDetails}
            parentValue={customObject(storeSalesDetails, '')}
            position={"bottom"}
            variant={'outlined'}
            searchType={(s) => receiptApi(s)}
            onChange={(d) => handleChangeCashReceipt(d.id)}
        />
    )
})